import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { HeaderCondensedComponent } from './header-condensed.component';

@NgModule({
  declarations: [HeaderCondensedComponent],
  exports: [HeaderCondensedComponent],
  imports: [CommonModule, IonicModule],
})
export class HeaderCondensedComponentModule {}
